import { useTranslation } from "react-i18next";

export const MFAAppLinks = () => {
  const { t } = useTranslation();

  return (
    <>
      Microsoft Authenticator (
      <a
        href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
        target="_blank"
        rel="noopener noreferrer"
      >
        iOS
      </a>{" "}
      /{" "}
      <a
        href="https://play.google.com/store/apps/details?id=com.azure.authenticator"
        target="_blank"
        rel="noopener noreferrer"
      >
        Android
      </a>
      ) {t("generic.and")} Google Authenticator (
      <a
        href="https://apps.apple.com/us/app/google-authenticator/id388497605"
        target="_blank"
        rel="noopener noreferrer"
      >
        iOS
      </a>{" "}
      /{" "}
      <a
        href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
        target="_blank"
        rel="noopener noreferrer"
      >
        Android
      </a>
      )
    </>
  );
};

export const SuggestedMFAApps = () => {
  const { t } = useTranslation();

  return (
    <p>
      {t("entry.mfa.suggestedApps")}
      <MFAAppLinks />
    </p>
  );
};
